var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageIndex == 0)?_c('LoginUserName',{attrs:{"vModel":_vm.vModel}}):(_vm.pageIndex == 1)?_c('LoginPassPhrase',{attrs:{"vModel":_vm.vModel}}):(_vm.pageIndex == 2)?_c('LoginPassWord',{attrs:{"vModel":_vm.vModel}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }